export default "__VITE_ASSET__DLGCiv45__"